"use client";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import SalifyLink from "src/lib/components/link/salify-link";
import { ComponentIconValue, resolveIconCssSize } from "src/lib/components/v2/icon-utils";
import { toAssetImages } from "src/lib/utils";
import TopBar, { TopBarProps, TopBarSocialLink } from "./default";

export interface IconTopBarProps extends TopBarProps {
  icon?: string | ComponentIconValue;
}

const BrandIcon = styled(Box)({
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
});

const SloganRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  minWidth: 0,
}));

const IconTopBar = ({ icon, slogan, socialLinks = [] }: IconTopBarProps) => {
  const iconAsset = resolveIconCssSize(icon, { width: "24px", height: "24px" });
  const visibleLinks = (socialLinks as TopBarSocialLink[]).filter(
    (item) => item.url || item.displayText,
  );

  if (!iconAsset.url) {
    return <TopBar slogan={slogan} socialLinks={socialLinks} />;
  }

  return (
    <TopBar
      slogan={
        <SloganRow>
          <BrandIcon>
            <Box
              component="img"
              src={toAssetImages(iconAsset.url)}
              alt=""
              sx={{
                width: iconAsset.width || "24px",
                height: iconAsset.height || "24px",
                objectFit: "contain",
                display: "block",
              }}
            />
          </BrandIcon>
          <Typography component="span" variant="body2" sx={{ color: "inherit" }}>
            {slogan || ""}
          </Typography>
        </SloganRow>
      }
      socialLinks={visibleLinks.length ? visibleLinks : socialLinks}
    />
  );
};

export default IconTopBar;
